<ng-container *ngIf="character">
  <div class="section saving-throws">
    <h4 class="section-header">Saving Throws</h4>

    <ul>
      <ng-container *ngFor="let attr of attributes">
        <li class="single-attribute"
            [class.proficient]="isProficient(attr)">
          <div class="indicator"></div>
          <div class="modifier"
              [innerText]="getSavingThrowModifier(attr)"
          ></div>
          <div class="label"
              [innerText]="attr"
          ></div>
        </li>
      </ng-container>

    </ul>
</div>
</ng-container>
